import { styled, css } from "styled-components";

export const CategoryTrigger = styled.div`
  cursor: pointer;
  min-height: 32px;
  height: 100%;
  padding: 0 20px;
  transition: 0.2s ease-out;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  line-height: 20px;

  > svg {
    transition: 0.2s ease-out;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.default[400]};
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    height: fit-content;
    padding: 12px 20px 12px 12px;
    font-size: 16px;
  }
`;

export const CategoryWrapper = styled.div<{
  $isOpen: boolean;
  $altStyling?: boolean;
}>`
  color: ${({ theme, $altStyling }) =>
          $altStyling ? theme.colors.primary[50] : theme.colors.default[900]};

  ${({ $isOpen }) =>
          $isOpen &&
          css`
      &::before {
        position: absolute;
        top: 100%;
        height: 100%;
        width: 100%;
        content: "";
        min-width: 200px;
        left: 50%;
        transform: translateX(-50%);
      }

      ${CategoryTrigger} {
        color: ${({ theme }) => theme.colors.primary[600]};

        > svg {
          transform: rotate(180deg);
        }
      }
    `}
  ${({ theme }) => theme.breakpoints.md.query} {
    display: flex;
    flex-direction: column;
    width: 100%;

    &::before {
      display: none;
    }
  }
`;

export const CategoryLinksWrapper = styled.div`
  position: absolute;
  top: calc(100% + 11px);
  width: 100vw;
  min-width: 100vw;
  overflow: clip;
  left: 50%;
  background: ${({ theme }) => theme.colors.base};
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.01);
  transform: translateX(-50%);
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.colors.default[100]};
  z-index: 10;

  ${({ theme }) => theme.breakpoints.md.query} {
    position: relative;
    left: revert;
    top: revert;
    width: 100%;
    transform: none;
    box-shadow: none;
    border: none;
  }
`;

export const NavigationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.colors.default[100]};
  ${({ theme }) => theme.breakpoints.md.query} {
    border-top: revert;
  }
`;

export const CategoryPopupContainer = styled.div<{ $hasCta?: boolean }>`
  width: 100%;
  height: 100%;
  min-height: max-content;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: flex;
  gap: 48px;
  padding: 48px 12px;
  overflow: clip;

  ${({ theme }) => theme.breakpoints.md.query} {
    max-width: revert;
    padding: 24px 0;
  }
`;

export const LinksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.md.query} {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 18px;
  }
`;
